import { useMemo, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useReactToPrint } from 'react-to-print'
import { Button, Modal } from 'reactstrap'
import images from '../../../api/images/hooks'
import notes from '../../../api/notes/hooks'
import { MODAL_TYPES } from '../../../common/constants'
import { hideModal } from '../../../store/modal'
import { resetTableCheckbox } from '../../../store/table'
import { useBlobUrls } from '../../Hooks/useBlobUrl'
import PrintContent from './PrintContent'
import { AgentPrintModalProps } from './types'

const AgentPrintModal = (props: AgentPrintModalProps) => {
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const contentRef = useRef<HTMLDivElement>(null)

    const { isOpen, agentPrintModal } = props
    const { id, agentPrintData, mainPhoto } = agentPrintModal

    const notesParams = useMemo(
        () => ({
            params: { id: Number(id), noteEntity: 'property' },
            queryParams: { limit: 100, page: 1, order: { noteDate: 'desc', id: 'desc' } },
        }),
        [id]
    )

    const { data: notesData } = notes.GetNotes.useQuery(notesParams)
    const notesItems = notesData?.items ?? []

    const [imageQuery] = images.GetImagesByUrl.useQueries(mainPhoto ? [mainPhoto] : [], '')
    const [imageSrc] = useBlobUrls([imageQuery].filter(Boolean))

    const handlePrint = useReactToPrint({
        contentRef,
        pageStyle: `
            @page {
                margin: 10px;
            }
        `,
    })

    const handleClose = () => {
        dispatch(hideModal({ modalType: MODAL_TYPES.AGENT_PRINT_MODAL }))
        dispatch(resetTableCheckbox(true))
    }

    return (
        <Modal isOpen={isOpen} centered size="lg">
            <div className="p-3">
                <div className="d-flex justify-content-end align-items-center mb-2">
                    {agentPrintData && (
                        <Button type="submit" color="send" className="btn-label me-2" onClick={() => handlePrint()}>
                            <i className="mdi mdi-printer-outline align-bottom label-icon align-middle fs-16 me-2"></i>
                            {t('app.common.print')}
                        </Button>
                    )}
                    <Button type="button" color="primary" className="btn-label" data-bs-dismiss="modal" onClick={handleClose}>
                        <i className="mdi mdi-close label-icon align-middle fs-16"></i>
                        {t('button.cancel')}
                    </Button>
                </div>
                {agentPrintData ? (
                    <PrintContent ref={contentRef} data={agentPrintData} notes={notesItems} imageSrc={imageSrc} />
                ) : (
                    <div className="text-center text-muted p-4">{t('app.common.noOptions')}</div>
                )}
            </div>
        </Modal>
    )
}

export default AgentPrintModal
